<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <sidebar-component classMenu="TemplateSetting"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="float-start">File Upload</h4>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    id="mainForm"
                    @submit.prevent="submitData"
                    method="POST"
                    enctype="multipart/form-data"
                  >
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          style="padding-left: 25px"
                          class="col-form-label"
                          >{{ $t("companyTxt") }}</label
                        >
                      </div>
                      <div class="col-lg-4">
                        <v-select
                          :options="fetchCompany"
                          v-model="selectedCompany"
                          @search="asyncSearchCompany"
                          return-object
                          label="code"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.code }} - {{ option.name }}
                          </template>
                        </v-select>
                        <div v-if="errors.company_id">
                          <div
                            v-for="error in errors.company_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          style="padding-left: 25px"
                          class="col-form-label"
                          >File</label
                        >
                      </div>
                      <div class="col-lg-6">
                        <input
                          type="file"
                          ref="file"
                          class="form-control"
                          @change="handleFileUpload($event)"
                        />
                        <div v-if="errors.file">
                          <div
                            v-for="error in errors.file"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="card-footer">
                  <button
                    class="btn btn-warning text-black fw-bolder btn-icon-text"
                    @click="backForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="arrow-left"></i>
                    {{ $t("backMess") }}
                  </button>

                  &nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-primary float-end btn-sm"
                    type="submit"
                    form="mainForm"
                  >
                    <i class="link-icon" data-feather="save"></i>
                    {{ $t("submitFormTxt") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
export default {
  name: "TemplateSettingIndex",
  computed: {},
  props: {},
  components: {
    sidebarComponent,
    navbarComponent,
    footerComponent,
  },
  data() {
    return {
      closeBtn: true,
      permision_role: [],
      isLoading: false,
      errors: [],
      fetchCompany: [],
      selectedCompany: null,
      file: null,
    };
  },
  watch: {},
  methods: {
    backForm() {
      window.location.href = "/dashboard";
    },
    submitData() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          let formData = new FormData();
          formData.append("file", this.file);
          formData.append("company_id", this.selectedCompany.company_id);
          const baseURI =
            this.$settings.endPointProformaInvoice + `v1/company-upload/upload`;

          this.$http
            .post(baseURI, formData)
            .then((response) => {
              if (response.data.status === 200) {
                this.errors = [];
                this.success(response.data.datas.messages);
                console.log(response);
                // console.log(response);
                // var params = this.$onRandom(
                //   response.data.datas.proforma_invoice_template_header_id,
                // );
                window.location.href = "/proforma-invoice/customer-list";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              if (error.code == "ECONNABORTED") {
                this.error("Please Check Your Internet Connection");
              }

              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            })
            .finally(() => {
              this.loading();
            });
        }
      });
    },
    loadCompany() {
      const baseURI = this.$settings.endPoint + `/company`;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncSearchCompany(ev, loading) {
      this.fetchCompany = [];
      // loading = true;
      // this.success(ev);
      loading(true);
      const baseURI = this.$settings.endPoint + `/company?code=${ev}`;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        })
        .finally(() => {
          loading(false);
        });
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "CustomerUploadController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
    resultError(data) {
      if (!data || typeof data !== "object") {
        this.error("Terjadi kesalahan validasi.");
        return;
      }

      this.showValidationErrorPopup(data);
    },
    showValidationErrorPopup(errors) {
      const entries = Object.entries(errors || {});

      if (!entries.length) {
        this.error("Terjadi kesalahan validasi.");
        return;
      }

      const tableRows = entries
        .map(([fieldKey, messages], index) => {
          const { rowLabel, fieldLabel } = this.parseValidationField(fieldKey);
          const messageList = Array.isArray(messages) ? messages : [messages];

          return `
            <tr>
              <td style="border:1px solid #dee2e6; padding:8px; vertical-align:top; text-align:center;">${index + 1}</td>
              <td style="border:1px solid #dee2e6; padding:8px; vertical-align:top;">${this.escapeHtml(rowLabel)}</td>
              <td style="border:1px solid #dee2e6; padding:8px; vertical-align:top;">${this.escapeHtml(fieldLabel)}</td>
              <td style="border:1px solid #dee2e6; padding:8px; vertical-align:top; text-align:left;">${messageList
                .map((message) => this.escapeHtml(message))
                .join("<br>")}</td>
            </tr>
          `;
        })
        .join("");

      this.$swal({
        icon: "error",
        title: "Validation Error",
        width: "900px",
        confirmButtonText: "Tutup",
        html: `
          <div style="max-height:450px; overflow:auto;">
            <table style="width:100%; border-collapse:collapse; font-size:13px;">
              <thead>
                <tr style="background-color:#f8f9fa;">
                  <th style="border:1px solid #dee2e6; padding:8px; text-align:center; width:60px;">No</th>
                  <th style="border:1px solid #dee2e6; padding:8px; text-align:left; width:120px;">Baris</th>
                  <th style="border:1px solid #dee2e6; padding:8px; text-align:left; width:180px;">Field</th>
                  <th style="border:1px solid #dee2e6; padding:8px; text-align:left;">Pesan Error</th>
                </tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
            </table>
          </div>
        `,
      });
    },
    parseValidationField(fieldKey) {
      const match = String(fieldKey || "").match(/^(\d+)\.(.+)$/);

      if (!match) {
        return {
          rowLabel: "-",
          fieldLabel: fieldKey || "-",
        };
      }

      const rowNumber = Number(match[1]) + 1;
      const fieldLabel = match[2].replace(/_/g, " ");

      return {
        rowLabel: `Baris ${rowNumber}`,
        fieldLabel,
      };
    },
    escapeHtml(value) {
      return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    fade(type) {
      this.isLoading = type;
    },
    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },
    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  mounted() {
    this.fetchIt();
    this.loadCompany();
  },
  created() {},
};
</script>
<style></style>
